import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackAgentMessageMissed.meta';
import { withWorkspaceAgentCategory } from './workspaceAgentAnalytics';

export type UseTrackAgentMessageMissedParams = {
  message_id: string;
  session_id: string;
};

export const useTrackAgentMessageMissed = () => {
  const { track } = useAnalyticsUtilities();

  const trackAgentMessageMissed = useCallback(
    (params: UseTrackAgentMessageMissedParams) => {
      track(META.name, withWorkspaceAgentCategory(params));
    },
    [track],
  );

  return { trackAgentMessageMissed };
};
